import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material'
import { PropsWithChildren } from 'react'

import { useSettings } from '@core/context/settingsContext'
import themeOptions from '@core/theme/ThemeOptions'

import { navThemeId } from '~/theme/themePreference'

export default function NavThemeProvider({ children }: PropsWithChildren) {
  const { settings } = useSettings()
  const theme = responsiveFontSizes(createTheme(themeOptions(settings, navThemeId(settings.themeId))))
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
